import { Row, Col, Typography } from 'antd';

const { Text, Paragraph } = Typography;

interface InputEditableProps {
  editing: any;
  inputComponent: any;
  label: any;
  helpText?: any;
  inputComponentProp?: any;
  getValue?: any;
  placeholder: string;
  type: string;
  className?: string;
  labelType?: boolean
  rowStyle?: React.CSSProperties;
  colStyle?: React.CSSProperties;
  [x: string]: any;
}

const InputEditable = ({
    editing, inputComponent, label, helpText, inputComponentProp, getValue, rowStyle, colStyle, labelType = true, ...props
}: InputEditableProps) => {
    const InputComponent = inputComponent;
    if (editing) {
        return (
            <Row gutter={{ sm: 20, md: 40 }} style={rowStyle}>
                <Col span={24} style={colStyle}>
                    <Text strong {...labelType ? { type: 'secondary' } : {}}>{label}</Text>
                </Col>
                <Col span={24} style={colStyle}>
                    <InputComponent {...props} />
                </Col>
                {helpText && (
                    <Col span={24}>
                        <Text className="help-text">
                            {helpText}
                        </Text>
                    </Col>
                )}
            </Row>
        );
    }
    return (
        <Row gutter={{ sm: 20, md: 40 }} style={rowStyle}>
            <Col span={12} style={colStyle}>
                <Text strong {...labelType ? { type: 'secondary' } : {}}>{label}</Text>
            </Col>
            <Col span={12} style={colStyle}>
                <Paragraph style={{ textAlign: 'right' }}>
                    {getValue ? (
                        getValue(props.value)
                    ) : (
                        props.value || 'No information'
                    )}
                </Paragraph>
            </Col>
        </Row>
    );
};

export default InputEditable;
